module.exports = __webpack_public_path__ + "static/media/Piercing-ear.d113df64.png";